import React, { useContext } from "react";
import ConopsFilterBar from "../conops-filterbar/conopsfilterbar";
import FacilityMap from "../conops-map/FacilityMap2"
import ConopsDataTable from "../conops-datatable/conopsdatatable"
import ConopsNewsList from "../conops-newslist/conopsnewslist";
import "./conopsdatapage.css"
import { ConopsContext } from "../../conops-hooks/ConopsContext";
import ConopsFacilityCountyTabs from "../conops-facility-county-tabs/conopsfacilitycountytabs"

const ConopsDataPage = () => {
  const { registerId, countyObject, selectedState, selectedCounty } = useContext(ConopsContext);
  return (
    <div className="conops-datapage">
      <div className="container-fluid">
        <div className="row">
          <div className="col-8">
            <div>
              <ConopsFilterBar />
            </div>
            <div>
              <FacilityMap />
            </div>
            <div>
              <ConopsDataTable />
            </div>
          </div>
          <div className="col-4">
            <div className="mt-4">
              {registerId ||
                (selectedState && selectedCounty) &&
                (countyObject?.county && countyObject?.state) ? (
                <ConopsFacilityCountyTabs />
              ) : (
                <ConopsNewsList />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default ConopsDataPage